import _defineProperty from "/src/main/react/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _jsxFileName = "/src/main/react/src/main/app/components/pages/Homepage.js";
import React, { Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { AppBar, Tabs, Tab, Grid, Paper, Typography, Button } from '@material-ui/core';
import { ImageGrid, ImageButtonList } from '../images';
import Footer from '../navigation/Footer';
import TpicPage from './TpicPage';
import Util from '../../util/Util';
import { IMAGEGRID_QUALIFIERS, BASE_URIS, LOCAL_STORAGE_ITEM_NAMES, IMAGE_BUTTON_LIST_QUALIFIERS, Q_STRING, BULK_ACTIONS, SORT_FIELD, TPIS_CAPABILITIES as CAPS } from "../domain/constants";
import { LOGIN } from "../Routes";
import queryString from "query-string";
import ImageBulkActionList from "../images/ImageBulkActionList";
import { changeSearchValue, changeSearchValues, retrieveFromQueryString, setUpTabInfoFromQueryString } from "../../util/QueryStringUtil";
import { stringToList } from "../../util/StringUtil";
const styles = theme => ({
  centeredContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
    maxWidth: '95vw',
    minWidth: '95vw'
  },
  tabs: {
    backgroundColor: theme.palette.background.paper,
    minWidth: '95vw',
    maxWidth: '95vw',
    margin: 0
  },
  imageGrid: {
    padding: '2vh',
    margin: '2vh',
    display: 'flex',
    justifyContent: 'center'
  }
});
class Homepage extends TpicPage {
  constructor(props) {
    super(props);
    _defineProperty(this, "handleTabChange", (event, value) => {
      this.setState({
        value
      });
      let params = {};
      params[Q_STRING.TAB] = value;
      params[Q_STRING.PAGE] = 1;
      params[Q_STRING.SORT_DESCENDING] = false;
      params[Q_STRING.SORT_FIELD] = SORT_FIELD.title;
      changeSearchValues(params, this.props);
    });
    const querystringValues = queryString.parse(this.props.location.search);
    const tab = determineTabValueFromQueryString(querystringValues);
    this.state = {
      value: tab !== -1 ? tab : determineDefaultTabValue(),
      role: localStorage.getItem(LOCAL_STORAGE_ITEM_NAMES.role) // This page just uses it for the div key
    };
    if (tab === -1) {
      changeSearchValue(Q_STRING.TAB, determineDefaultTabValue(), props);
    }
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    const defaultValue = determineDefaultTabValue();
    const querystringValues = queryString.parse(this.props.location.search);
    const tabValueFromQString = determineTabValueFromQueryString(querystringValues);
    setUpTabInfoFromQueryString(this, prevState, defaultValue, querystringValues, tabValueFromQString);
  }
  render() {
    const classes = this.props.classes;
    const _this$state = this.state,
      value = _this$state.value,
      role = _this$state.role;
    const caps = stringToList(localStorage.getItem(LOCAL_STORAGE_ITEM_NAMES.capabilities));
    if (value !== -1) {
      return /*#__PURE__*/React.createElement("div", {
        id: "grid-container",
        className: classes.centeredContainer,
        key: "".concat(value, "-").concat(role),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 84,
          columnNumber: 17
        }
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        direction: "column",
        spacing: 1,
        justify: "space-around",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 85,
          columnNumber: 21
        }
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        container: true,
        direction: "column",
        alignContent: "center",
        justify: "center",
        spacing: 5,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 86,
          columnNumber: 25
        }
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 88,
          columnNumber: 29
        }
      }, /*#__PURE__*/React.createElement(Paper, {
        elevation: 0,
        style: {
          marginTop: '2vh',
          minWidth: '95vw',
          maxWidth: '95vw',
          overflow: 'hidden'
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 89,
          columnNumber: 33
        }
      }, /*#__PURE__*/React.createElement(AppBar, {
        position: "sticky",
        style: {
          overflow: 'hidden'
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 95,
          columnNumber: 37
        }
      }, /*#__PURE__*/React.createElement(Tabs, {
        value: value,
        variant: "scrollable",
        onChange: this.handleTabChange,
        style: {
          overflow: 'hidden'
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 98,
          columnNumber: 41
        }
      }, caps != null && Util.isVisibleForCapabilities(caps, [CAPS.READ]) && [/*#__PURE__*/React.createElement(Tab, {
        label: "On Platform",
        value: 0,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 103,
          columnNumber: 49
        }
      }), /*#__PURE__*/React.createElement(Tab, {
        label: "Orphaned",
        value: 1,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 104,
          columnNumber: 49
        }
      })], caps != null && Util.isVisibleForCapabilities(caps, [CAPS.AUDIT, CAPS.PUBLISH]) && /*#__PURE__*/React.createElement(Tab, {
        label: "All",
        value: 2,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 107,
          columnNumber: 45
        }
      }), caps != null && Util.isVisibleForCapabilities(caps, [CAPS.AUDIT]) && [/*#__PURE__*/React.createElement(Tab, {
        label: "Audit Pending",
        value: 3,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 112,
          columnNumber: 49
        }
      }), /*#__PURE__*/React.createElement(Tab, {
        label: "Quick Audit",
        value: 4,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 113,
          columnNumber: 49
        }
      }), /*#__PURE__*/React.createElement(Tab, {
        label: "Bulk Audit",
        value: 9,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 114,
          columnNumber: 49
        }
      })], caps != null && Util.isVisibleForCapabilities(caps, [CAPS.AUDIT, CAPS.READ]) && [/*#__PURE__*/React.createElement(Tab, {
        label: "Approved",
        value: 5,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 119,
          columnNumber: 49
        }
      }), /*#__PURE__*/React.createElement(Tab, {
        label: "Rejected",
        value: 8,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 120,
          columnNumber: 49
        }
      })], caps != null && Util.isVisibleForCapabilities(caps, [CAPS.PUBLISH]) && [/*#__PURE__*/React.createElement(Tab, {
        label: "Publish Pending",
        value: 6,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 125,
          columnNumber: 49
        }
      }), /*#__PURE__*/React.createElement(Tab, {
        label: "Bulk Publish",
        value: 10,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 126,
          columnNumber: 49
        }
      }), /*#__PURE__*/React.createElement(Tab, {
        label: "Publish Failed",
        value: 11,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 127,
          columnNumber: 49
        }
      })], /*#__PURE__*/React.createElement(Tab, {
        label: "Published",
        value: 7,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 129,
          columnNumber: 45
        }
      }))), value === 0 && caps != null && Util.isVisibleForCapabilities(caps, [CAPS.READ]) && /*#__PURE__*/React.createElement(ImageGrid, {
        qualifier: IMAGEGRID_QUALIFIERS.all,
        baseUri: BASE_URIS.listPrograms,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 134,
          columnNumber: 37
        }
      }), value === 1 && caps != null && Util.isVisibleForCapabilities(caps, [CAPS.READ]) && /*#__PURE__*/React.createElement(ImageGrid, {
        qualifier: IMAGEGRID_QUALIFIERS.orphaned,
        baseUri: BASE_URIS.listOrphans,
        allowSort: false // listOrphans does not support sort
        ,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 140,
          columnNumber: 37
        }
      }), value === 2 && caps != null && Util.isVisibleForCapabilities(caps, [CAPS.AUDIT, CAPS.PUBLISH]) && /*#__PURE__*/React.createElement(ImageGrid, {
        qualifier: IMAGEGRID_QUALIFIERS.all,
        baseUri: BASE_URIS.listPrograms,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 147,
          columnNumber: 37
        }
      }), value === 3 && caps != null && Util.isVisibleForCapabilities(caps, [CAPS.AUDIT]) && /*#__PURE__*/React.createElement(ImageGrid, {
        qualifier: IMAGEGRID_QUALIFIERS.audit,
        baseUri: BASE_URIS.listAssociations,
        allowSort: false,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 153,
          columnNumber: 37
        }
      }), value === 4 && caps != null && Util.isVisibleForCapabilities(caps, [CAPS.AUDIT]) && /*#__PURE__*/React.createElement(ImageButtonList, {
        qualifier: IMAGE_BUTTON_LIST_QUALIFIERS.quickAudit,
        baseUri: BASE_URIS.listAssociations,
        allowSort: false,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 160,
          columnNumber: 37
        }
      }), value === 9 && caps != null && Util.isVisibleForCapabilities(caps, [CAPS.AUDIT]) && /*#__PURE__*/React.createElement(ImageBulkActionList, {
        action: BULK_ACTIONS.AUDIT,
        baseUri: BASE_URIS.listAssociations,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 167,
          columnNumber: 37
        }
      }), value === 5 && caps != null && Util.isVisibleForCapabilities(caps, [CAPS.AUDIT, CAPS.READ]) && /*#__PURE__*/React.createElement(ImageGrid, {
        qualifier: IMAGEGRID_QUALIFIERS.approved,
        baseUri: BASE_URIS.listAssociations,
        allowSort: false,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 174,
          columnNumber: 37
        }
      }), value === 8 && caps != null && Util.isVisibleForCapabilities(caps, [CAPS.AUDIT, CAPS.READ]) && /*#__PURE__*/React.createElement(ImageGrid, {
        qualifier: IMAGEGRID_QUALIFIERS.rejected,
        baseUri: BASE_URIS.listAssociations,
        allowSort: false,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 181,
          columnNumber: 37
        }
      }), value === 6 && caps != null && Util.isVisibleForCapabilities(caps, [CAPS.PUBLISH]) && /*#__PURE__*/React.createElement(ImageGrid, {
        qualifier: IMAGEGRID_QUALIFIERS.publish,
        baseUri: BASE_URIS.listAssociations,
        allowSort: false,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 188,
          columnNumber: 37
        }
      }), value === 10 && caps != null && Util.isVisibleForCapabilities(caps, [CAPS.PUBLISH]) && /*#__PURE__*/React.createElement(ImageBulkActionList, {
        action: BULK_ACTIONS.PUBLISH,
        baseUri: BASE_URIS.listAssociations,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 195,
          columnNumber: 37
        }
      }), value === 11 && caps != null && Util.isVisibleForCapabilities(caps, [CAPS.PUBLISH]) && /*#__PURE__*/React.createElement(ImageGrid, {
        qualifier: IMAGEGRID_QUALIFIERS.publishFailed,
        baseUri: BASE_URIS.listAssociations,
        allowSort: false,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 202,
          columnNumber: 37
        }
      }), value === 7 && caps != null && /*#__PURE__*/React.createElement(ImageGrid, {
        qualifier: IMAGEGRID_QUALIFIERS.published,
        baseUri: BASE_URIS.listAssociations,
        allowSort: false,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 209,
          columnNumber: 37
        }
      }), /*#__PURE__*/React.createElement(Footer, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 214,
          columnNumber: 37
        }
      }))))));
    } else {
      try {
        Util.loginRedirect(this.props);
        return null;
      } catch (e) {
        // Render a message and a button to redirect the user if not able to automatically redirect
        Util.log('Homepage.render', true, e, false);
        return /*#__PURE__*/React.createElement(Fragment, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 229,
            columnNumber: 21
          }
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "h6",
          align: 'center',
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 230,
            columnNumber: 25
          }
        }, "TPIS responded with an unexpected role. Please click ", /*#__PURE__*/React.createElement(Button, {
          onClick: () => this.routeLogin(),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 231,
            columnNumber: 35
          }
        }, "here"), " to log in again"));
      }
    }
  }
  routeLogin() {
    this.props.history.push(LOGIN);
  }
}

/**
 * The value of "value" is what determines the active tab. Since the same default tab is not visible to all users, call this function
 * to determine which tab should be set as the landing page tab
 * @returns {number}
 */
function determineDefaultTabValue() {
  let caps = localStorage.getItem(LOCAL_STORAGE_ITEM_NAMES.capabilities);
  if (caps == null) {
    return -1;
  }
  if (caps.includes(CAPS.ADMIN) || caps.includes(CAPS.READ)) {
    // default is On Platform
    return 0;
  } else if (caps.includes(CAPS.AUDIT) || caps.includes(CAPS.PUBLISH)) {
    // On Platform/Orphaned tabs aren't available to users with only these caps
    return 2;
  }
  return -1;
}

/**
 * Users can pass any value in the t= param so we have to check if they're
 * allowed to view the contents of that tab anyway (it won't even show up for them
 * if their capabilities don't allow it anyway)
 * @returns {number}
 */
function determineTabValueFromQueryString(querystringValues) {
  try {
    let tab = retrieveFromQueryString(Q_STRING.TAB, querystringValues);
    let tabInt = -1;
    if (tab != null && tab !== '') {
      tabInt = parseInt(tab, 10);
    } else {
      return -1;
    }
    if (tabInt >= 0 && tabInt <= 11) {
      let caps = localStorage.getItem(LOCAL_STORAGE_ITEM_NAMES.capabilities);
      if (caps == null) {
        return -1;
      }
      if (caps.includes(CAPS.AUDIT)) {
        // On Platform/Orphaned tabs aren't available to these users
        if (tabInt !== -1 && [2, 3, 4, 5, 7, 8, 9].includes(tabInt)) {
          return tabInt;
        }
      } else if (caps.includes(CAPS.PUBLISH)) {
        if (tabInt !== -1 && [2, 6, 7, 10, 11].includes(tabInt)) {
          return tabInt;
        }
      } else if (caps.includes(CAPS.READ)) {
        // On Plat/Orphaned/Approved/Published/Rejected
        if (tabInt !== -1 && [0, 1, 5, 7, 8].includes(tabInt)) {
          return tabInt;
        }
      } else if (caps.includes(CAPS.ADMIN)) {
        // Admin can see any tab
        if (tabInt !== -1) {
          return tabInt;
        }
      }
    }
  } catch (e) {
    Util.log('Homepage.determineTabValueFromQueryString', true, e.message, true);
  }
  return -1;
}
export default withStyles(styles)(withRouter(Homepage));